import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import {
    INITIATE_IMPERSONATION_SUCCESS,
    INITIATE_IMPERSONATION_FAILURE,
} from '../actions';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* getImpersonationKey() {
    let basesiteid = localStorage.getItem('baseSiteId');

    const principalUser = sessionStorage.getItem('impersonatedUserId');
    const url = `/occ/v2/${basesiteid}/impersonation/impersonate`;
    try {
        const result = yield axios({
            method: 'post',
            url: url,
            headers: {
                PrincipalUser: principalUser,
            },
        }).then((response) => response.data);
        sessionStorage.removeItem('impersonationEndFlag');
        sessionStorage.setItem('impersonationFlag', true);
        sessionStorage.setItem('impersonationKey', result.impersonationKey);
        yield put({ type: INITIATE_IMPERSONATION_SUCCESS, data: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: { principalUser }
        });
        yield put({
            type: INITIATE_IMPERSONATION_FAILURE,
            templateError: true,
        });
    }
}
